import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { isEqual } from 'lodash';
import { CSSTransition } from 'react-transition-group';
import videojs from 'video.js';
import { VideoJsGlobalStyle, Wrapper, CenterPlayButton, ToggleVeil, VolumeControl, VideoContainer } from './styledComponents.mjs';
import { MediaLazyTransitionWrapper } from '../mediaWrapper/index.mjs';
import { ErrorBoundary } from '../errorBoundary/index.mjs';

var VIDEO_OPTION = {
  preload: "auto",
  html5: {
    nativeControlsForTouch: false,
    nativeAudioTracks: false,
    nativeTextTracks: false,
    nativeVideoTracks: false,
    hls: {
      overrideNative: true
    }
  }
};
var RawHlsVideo = /*#__PURE__*/function (_React$PureComponent) {
  function RawHlsVideo() {
    var _this;
    _classCallCheck(this, RawHlsVideo);
    var _a, _b;
    _this = _callSuper(this, RawHlsVideo, arguments);
    _this.state = {
      isPlayed: false,
      pipButtonVisible: _this.props.isAudio ? false : true,
      playStatus: (_a = _this.props.autoPlay) !== null && _a !== void 0 ? _a : false,
      muteStatus: (_b = _this.props.muted) !== null && _b !== void 0 ? _b : true
    };
    _this.player = null;
    _this.getSources = function () {
      var sources = _this.props.sources;
      return sources.filter(function (v) {
        return Boolean(v);
      });
    };
    _this.renderSourceNodes = function () {
      return _this.getSources().map(function (source) {
        return jsx("source", {
          src: source.src,
          type: source.type
        }, source.src);
      });
    };
    _this.renderVideo = function () {
      var _this$props = _this.props,
        poster = _this$props.poster;
        _this$props.fluid;
        _this$props.ref;
        var className = _this$props.className,
        muted = _this$props.muted;
      return jsx(VideoContainer, {
        playsInline: true,
        className: "video-js vjs-default-skin ".concat(className ? className : ""),
        controlsList: "nodownload",
        ref: _this.initialize,
        poster: poster,
        muted: muted,
        children: _this.renderSourceNodes()
      });
    };
    _this.initialize = function (node) {
      if (node) {
        _this.player = videojs(node, _this.getPlayerOptions());
        _this.player.one("play", function () {
          _this.setState({
            isPlayed: true
          });
        });
        _this.player.on("play", function () {
          _this.setState({
            playStatus: true
          });
        });
        _this.player.on("pause", function () {
          _this.setState({
            playStatus: false
          });
        });
        _this.player.on("volumechange", function (e) {
          _this.setState({
            muteStatus: e.target.player.muted()
          });
        });
      }
    };
    _this.getPlayerOptions = function () {
      var _this$props2 = _this.props,
        autoPlay = _this$props2.autoPlay,
        muted = _this$props2.muted,
        height = _this$props2.height,
        width = _this$props2.width,
        poster = _this$props2.poster,
        fluid = _this$props2.fluid,
        controls = _this$props2.controls,
        staticRatio = _this$props2.staticRatio,
        loop = _this$props2.loop;
      return Object.assign(Object.assign({}, VIDEO_OPTION), {
        bigPlayButton: false,
        height: height,
        width: width,
        poster: poster,
        playbackRates: [0.25, 0.5, 1, 1.5, 2],
        fluid: !!fluid,
        aspectRatio: staticRatio === "unset" ? undefined : (staticRatio !== null && staticRatio !== void 0 ? staticRatio : width && height) ? "".concat(width, ":").concat(height) : "16:9",
        controlBar: {
          seekToLive: false,
          liveDisplay: false,
          pictureInPictureToggle: false
        },
        controls: controls,
        autoplay: autoPlay,
        muted: muted,
        playsinline: true,
        loop: loop
      });
    };
    _this.handleVeilClick = function () {
      var _a, _b, _c;
      if ((_a = _this.player) === null || _a === void 0 ? void 0 : _a.paused()) {
        (_b = _this.player) === null || _b === void 0 ? void 0 : _b.play();
      } else {
        (_c = _this.player) === null || _c === void 0 ? void 0 : _c.pause();
      }
    };
    _this.handleVolumeControlClick = function () {
      var _a, _b;
      (_a = _this.player) === null || _a === void 0 ? void 0 : _a.muted(!((_b = _this.player) === null || _b === void 0 ? void 0 : _b.muted()));
    };
    return _this;
  }
  _inherits(RawHlsVideo, _React$PureComponent);
  return _createClass(RawHlsVideo, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      if (!isEqual(this.props.sources, prevProps.sources)) {
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.pause();
        (_b = this.player) === null || _b === void 0 ? void 0 : _b.src(this.props.sources);
        (_c = this.player) === null || _c === void 0 ? void 0 : _c.load();
      }
      if (this.props.muted !== prevProps.muted) {
        this.setState({
          muteStatus: (_d = this.props.muted) !== null && _d !== void 0 ? _d : true
        });
        (_e = this.player) === null || _e === void 0 ? void 0 : _e.load();
      }
      if (this.props.poster !== prevProps.poster && this.props.poster) {
        (_f = this.player) === null || _f === void 0 ? void 0 : _f.poster(this.props.poster);
      }
      if (this.props.controls !== prevProps.controls) {
        (_g = this.player) === null || _g === void 0 ? void 0 : _g.controls(Boolean(this.props.controls));
      }
      if (this.props.autoPlay !== prevProps.autoPlay) {
        this.setState({
          playStatus: (_h = this.props.autoPlay) !== null && _h !== void 0 ? _h : false
        });
        if (this.props.autoPlay) {
          (_j = this.player) === null || _j === void 0 ? void 0 : _j.play();
        } else {
          (_k = this.player) === null || _k === void 0 ? void 0 : _k.pause();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.player) {
        this.player.dispose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        previewColor = _this$props3.previewColor,
        blurHash = _this$props3.blurHash,
        width = _this$props3.width,
        height = _this$props3.height,
        style = _this$props3.style,
        disableSkeleton = _this$props3.disableSkeleton,
        disableMediaOpacity = _this$props3.disableMediaOpacity;
      var sources = this.getSources();
      return jsxs(ErrorBoundary, {
        children: [jsx(VideoJsGlobalStyle, {}), jsxs(Wrapper, {
          style: style,
          children: [sources.length && width && height ? jsx(MediaLazyTransitionWrapper, {
            src: sources[0].src,
            type: "video",
            width: width,
            height: height,
            previewColor: previewColor,
            blurHash: blurHash,
            disableSkeleton: disableSkeleton,
            disableMediaOpacity: disableMediaOpacity,
            children: this.renderVideo()
          }) : jsx("div", {
            children: this.renderVideo()
          }), !this.props.autoPlay && !this.state.isPlayed && jsx(CenterPlayButton, {
            playStatus: false,
            style: {
              visibility: "visible"
            },
            onClick: this.handleVeilClick
          }), !this.props.controls && jsxs(Fragment, {
            children: [jsx(ToggleVeil, {
              onClick: this.handleVeilClick
            }), jsx(CSSTransition, {
              "in": this.state.playStatus,
              timeout: 600,
              classNames: "playButtonAnim",
              children: jsx(CenterPlayButton, {
                playStatus: !this.state.playStatus
              })
            }), !this.props.disableMuteButton && jsx(VolumeControl, {
              className: "vjs-icon-placeholder",
              muted: this.state.muteStatus,
              onClick: this.handleVolumeControlClick
            })]
          })]
        })]
      });
    }
  }]);
}(React.PureComponent);

export { RawHlsVideo };
